<template>
  <section class="partners-section">

    <div class="container">

      <div class="header">

        <h1>
          Nos associations partenaires
        </h1>

        <p>
          HayMiutyun souhaite construire un réseau solide avec les associations
          arméniennes et les acteurs engagés afin de renforcer l'entraide,
          partager les ressources et mieux accompagner notre communauté.
        </p>

      </div>


      <div class="intro-card">

        <div class="intro-icon">
          +
        </div>

        <div>

          <h2>
            Pourquoi collaborer avec des associations ?
          </h2>

          <p>
            Les associations jouent un rôle essentiel dans la vie de notre
            communauté. Elles organisent des événements, accompagnent les
            personnes dans le besoin, préservent notre culture et créent
            des liens entre les générations.
          </p>

          <p>
            Grâce à ces collaborations, HayMiutyun souhaite faciliter les
            échanges, orienter les personnes vers les bonnes structures et
            développer des projets communs.
          </p>

        </div>

      </div>


      <h2 class="section-title">
        Le rôle de nos partenaires
      </h2>


     <div class="roles">

  <div class="role-card">

   <div class="role-icon">
    <HandHeart />
  </div>

    <h3>
      Solidarité
    </h3>

    <p>
      Aider les personnes en difficulté et proposer un accompagnement
      adapté aux besoins de chacun.
    </p>

  </div>


  <div class="role-card">

    <div class="role-icon">
      <BookOpen />
    </div>

    <h3>
      Culture & Transmission
    </h3>

    <p>
      Préserver notre histoire, notre langue et nos traditions
      auprès des nouvelles générations.
    </p>

  </div>


  <div class="role-card">

   <div class="role-icon">
    <UsersRound />
  </div>

    <h3>
      Mise en relation
    </h3>

    <p>
      Créer des ponts entre les membres de la communauté et les
      structures capables de les accompagner.
    </p>

  </div>


</div>



      <h2 class="section-title">
        Nos associations partenaires
      </h2>


      <div class="partners-grid">

        <div
          v-for="(partner,index) in partners"
          :key="index"
          class="partner-card"
        >

          <div class="logo">

            <img
              v-if="partner.image"
              :src="partner.image"
              :alt="partner.name"
            />

            <span v-else>
              +
            </span>

          </div>


          <h3>
            {{ partner.name }}
          </h3>


          <p>
            {{ partner.description }}
          </p>


          <button>
            Découvrir
          </button>


        </div>


      </div>



      <div class="cta">


        <h2>
          Vous êtes une association ?
        </h2>


        <p>
          Rejoignez notre réseau et construisons ensemble une communauté
          arménienne plus unie et solidaire.
        </p>


        <button @click="goToPartner">
          Devenir partenaire
        </button>


      </div>


    </div>

  </section>
</template>


<script setup>

import { useRouter } from 'vue-router'
import { HandHeart, BookOpen, UsersRound } from "lucide-vue-next"

const router = useRouter()

const goToPartner = () => {
  router.push('/become')
}

const partners = [

{
name:"Association partenaire",
description:
"Une association engagée dans l'entraide et le soutien de la communauté arménienne.",
image:null
},


{
name:"Association partenaire",
description:
"Une structure qui participe à la préservation culturelle et au développement de projets communautaires.",
image:null
},


{
name:"Association partenaire",
description:
"Un acteur local qui accompagne les membres de la communauté dans leurs démarches.",
image:null
}

];


</script>


<style scoped>

*{
  box-sizing:border-box
}

.partners-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc)
}

.container{
  max-width:1200px;
  width:100%;
  margin:auto
}

.header{
  text-align:center;
  margin-bottom:50px
}

.header h1{
  font-size:48px;
  font-weight:800;
  margin:0 0 15px;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}

.header p{
  max-width:800px;
  margin:auto;
  font-size:18px;
  line-height:1.8;
  color:#666
}


.intro-card{
  display:flex;
  align-items:center;
  gap:35px;
  background:white;
  padding:35px;
  border-radius:30px;
  box-shadow:0 15px 40px rgba(0,0,0,.08);
  margin-bottom:60px;
  border-left:5px solid #D90012
}


.intro-icon{
  width:75px;
  height:75px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:25px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:35px;
  font-weight:bold;
  flex-shrink:0
}


.intro-card h2{
  font-size:30px;
  margin:0 0 15px
}

.intro-card p{
  color:#666;
  line-height:1.8
}


.section-title{
  text-align:center;
  font-size:32px;
  margin-bottom:35px
}


.roles{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px;
  margin-bottom:60px
}


.role-card{
  background:white;
  padding:30px;
  border-radius:25px;
  text-align:center;
  box-shadow:0 10px 30px rgba(0,0,0,.07);
  transition:.3s;
  border-top:4px solid transparent
}


.role-card:nth-child(1){
  border-color:#D90012
}

.role-card:nth-child(2){
  border-color:#0033A0
}

.role-card:nth-child(3){
  border-color:#F2A800
}


.role-card:hover{
  transform:translateY(-7px)
}


.role-icon{
  width:60px;
  height:60px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  background:#fff1f2;
  color:#D90012;
  font-size:28px;
  font-weight:bold
}


.role-card h3{
  font-size:22px
}


.role-card p{
  color:#666;
  line-height:1.7
}


.partners-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px
}


.partner-card{
  background:white;
  padding:30px;
  border-radius:25px;
  text-align:center;
  box-shadow:0 15px 40px rgba(0,0,0,.08);
  transition:.3s
}


.partner-card:hover{
  transform:translateY(-8px)
}


.logo{
  width:90px;
  height:90px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff1f2;
  color:#D90012;
  font-size:40px;
  font-weight:bold;
  overflow:hidden
}


.logo img{
  width:100%;
  height:100%;
  object-fit:cover
}


.partner-card h3{
  font-size:22px
}


.partner-card p{
  color:#666;
  line-height:1.7
}


.partner-card button,
.cta button{
  padding:15px 35px;
  border:none;
  border-radius:30px;
  color:white;
  font-weight:700;
  cursor:pointer;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  transition:.3s
}


.partner-card button:hover,
.cta button:hover{
  transform:translateY(-3px)
}


.cta{
  margin-top:60px;
  padding:40px;
  text-align:center;
  background:white;
  border-radius:30px;
  border:3px solid #D90012;
  box-shadow:0 15px 40px rgba(0,0,0,.08)
}


.cta h2{
  font-size:32px
}


.cta p{
  font-size:18px;
  color:#666;
  margin-bottom:25px
}


@media(max-width:900px){

  .roles,
  .partners-grid{
    grid-template-columns:1fr
  }

  .intro-card{
    flex-direction:column;
    text-align:center
  }

  .header h1{
    font-size:36px
  }

}


@media(max-width:480px){

  .partners-section{
    padding:25px 15px
  }

  .header h1{
    font-size:32px
  }

  .intro-card,
  .role-card,
  .partner-card,
  .cta{
    padding:25px 20px
  }

}

</style>